import React from 'react'

import { Text } from '@chilipiper/design-system'
import { usePickTitleText, Params as Props } from './hooks'

export const PickTitle = (props: Props) => {
  const title = usePickTitleText(props)
  return (
    <Text
      data-test-id='PickTitle'
      mb={1}
      color='neutral-dark-80'
      textStyle='body-monoline'
      data-chili-css='book-text'
      display='block'
    >
      {title}
    </Text>
  )
}
